<template>
  <div class="vote">
    <Vote :voteInfo="voteInfo" :userid="userid" v-if="voteType === 1" />
    <Questionnaire :voteInfo="voteInfo" :userid="userid" v-else-if="voteType === 2" />
  </div>
</template>

<script>
import { reactive, toRefs, watch } from "vue"
import { api } from "@/api"
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Questionnaire from '@/components/common/vote/Questionnaire'
import Vote from '@/components/common/vote/Vote'
export default {
  name: "show-vote",
  components: { Questionnaire, Vote },
  setup() {
    const store = useStore()
    const route = useRoute()
    let initData = reactive({
      userid: "anonymous",
      voteInfo: "",
      voteType: -1, // 1 投票 2 问卷
      
    })
    watch(() => store.state.userInfo, (value) => {
      if(value) {
        initData.userid = value.id
      }
      getInfo()
    }, {immediate: true});
    function getInfo() {
      let data = {
          articleid: route.query.id,
          userid: initData.userid
        }
      api("get", "getvote", data).then(res => {
        if(res.code === 1200) {
          initData.voteInfo = res.data
          // votetype 1 单项调查问卷 2 多项调查问卷 3 测评问卷（得分） 4 视频单选投票 5 视频单项多选投票
          if(res.data.votetype*1 === 1 || res.data.votetype*1 === 2 || res.data.votetype*1 === 3) {
            initData.voteType = 2
          } else {
            initData.voteType = 1
          }
        }
      })
    }
    return {
      ...toRefs(initData)
    }
  }
}
</script>

<style lang="less" scoped>

</style>